import React from 'react';
import { styled } from '@linaria/react';
import { CHOTOT_LOGO, JOB_LOGO, PTY_LOGO, VEH_LOGO } from '~/constants';
import config from '~/config';
const Logos = () => <Wrapper>
    <p>Được phát triển bởi</p>
    <div>
      <a href={config.baseUrl} target="_blank">
        <img src={CHOTOT_LOGO} alt="Chotot Logo" />
      </a>
      <a href={config.ptyBaseUrl} target="_blank">
        <img src={PTY_LOGO} alt="Nhatot Logo" />
      </a>
      <a href={config.jobBaseUrl} target="_blank">
        <img src={JOB_LOGO} alt="Vieclamtot Logo" />
      </a>
      <a className="veh-link" href={config.vehBaseUrl} target="_blank">
        <img src={VEH_LOGO} alt="Chotot Xe Logo" />
      </a>
    </div>
  </Wrapper>;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wzjkpvr",
  propsAsIs: false
});
export default Logos;

require("./Logos.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@4.1.17_webpack@5.83.1/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Logos.tsx");